const theme = {
  blueDark: "#00A8E8",
  bluelight: "#91D9D9",
  blueDarkRgb: "66,174,186",
  bluelightRgb: "145,217,217",
  white: "#FAF4ED",
  redrgb: "255,140,133",
  yellow: "FFDF85",
  greenDark: "#8EBFA3",
  brownLight: "#E6D0BE",
  brownMedium: "#DBBE9D",
  brownDark: "#583E3B",
  brownDarkRgb: "88,62,59",
  brownDarkTextColor: "#3F2B29",
  greenDarkTextColor: "#253925",
  red: "255,0,0",
  black: "#000000",
  grey: "100,100, 100",
};

export default theme;
